export default "__VITE_ASSET__CPlXqCo0__"